import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ApplicationContainer from './containers/ApplicationContainer';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { UrlService } from './services';
import isValidProp from '@emotion/is-prop-valid';
import { StyleSheetManager } from 'styled-components';

const rootElement = document.documentElement;

if (UrlService.getPlatform() === 'kiosk' && rootElement) {
	rootElement.style.fontSize = '125%';
}

const appElement = document.getElementById('app');
ReactDOM.render(
	<Provider store={store}>
		<PersistGate persistor={persistor}>
			<StyleSheetManager shouldForwardProp={(propName) => isValidProp(propName)}>
				<ApplicationContainer />
			</StyleSheetManager>
		</PersistGate>
	</Provider>,
	appElement
);
